import Vue from "vue";

//-------------------lib---------------------
import Element from "element-ui";
// import watermark from 'watermark-dom'

//-------------------css---------------------
import "@/assets/style/index.scss";
// import 'element-ui/lib/theme-chalk/index.css';

//-------------------define---------------------
import BaseComponents from "@/components/base";
import Directives from "@/directives";
import Api from "./api";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import MainMixins from "@/mixin";
import Filters from "@/filter";
import * as Util from "@/assets/js/util";
import * as filter from "@/assets/js/filter";
import MainDirective from "@/directives";
import doCoveringLogicWithElement from "@/assets/js/override_element";

// 全局util方法注册
Vue.prototype.$util = Util;

// 全局过滤器注册
Object.keys(filter).forEach((key) => {
  Vue.filter(key, filter[key]);
});

// 全局注册组件
Vue.use(BaseComponents);
Vue.use(Directives);
Vue.use(Api);
Vue.use(MainDirective);
Vue.use(doCoveringLogicWithElement(Element));
Vue.use(MainMixins);
Object.keys(Filters).forEach((key) => Vue.filter(key, Filters[key]));

Vue.config.productionTip = false;

window.CMS_NAME_SPACE = {};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
